import _ from 'lodash';
import {
    FLEXI_24_PRODUCT_TYPE,
    FLEXI_LOAN_PRODUCT_TYPE
} from '../myAccount/multiLoanDashboard/accountsSelector';
import { LOAN_STATUSES } from '../myAccount/dashboard/constants';
import { GetAccountsResponse } from '@iwoca/lapi-client/edge';

type TState = {
    [apiName: string]: {
        data: any;
        pending: boolean;
        method?: string;
    };
};
type TAction = { type: string; response: any };

export function apiReducer(
    { apiName, apiMethod }: { apiName: string; apiMethod: string },
    state: TState,
    action: TAction
) {
    const apiStateName = apiName.toLowerCase();

    switch (action.type) {
        case `api/GET_${apiName} [pending]`:
        case `api/POST_${apiName} [pending]`:
            return {
                ...state,
                [apiStateName]: {
                    data: _.get(state, `${apiStateName}.data`),
                    pending: action.response.pending,
                    method: apiMethod === 'POST' ? 'POST' : undefined
                }
            };

        case `api/GET_${apiName} [success]`:
        case `api/GET_${apiName} [fail]`:
        case `api/POST_${apiName} [success]`:
        case `api/POST_${apiName} [fail]`:
            return {
                ...state,
                [apiStateName]: action.response
            };

        case `api/PUT_${apiName} [pending]`:
        case `api/PUT_${apiName} [success]`:
        case `api/PUT_${apiName} [fail]`:
        case `api/DELETE_${apiName} [pending]`:
        case `api/DELETE_${apiName} [success]`:
        case `api/DELETE_${apiName} [fail]`:
            return {
                ...state,
                [apiStateName]: {
                    data: _.get(state, `${apiStateName}.data`),
                    pending: action.response.pending,
                    method: apiMethod
                }
            };
    }
}

export function accountsApiReducerWithMultiProductFix(
    { apiName }: { apiName: string },
    state: TState,
    action: TAction
) {
    const apiStateName = apiName.toLowerCase();

    switch (action.type) {
        case `api/GET_${apiName} [pending]`:
            return {
                ...state,
                [apiStateName]: {
                    data: _.get(state, `${apiStateName}.data`),
                    pending: action.response.pending
                }
            };

        case `api/GET_${apiName} [success]`:
            return {
                ...state,
                [apiStateName]:
                    fixAccountsResponseWithUnsupportedMultiProductAccounts(
                        action.response
                    )
            };
        case `api/GET_${apiName} [fail]`:
            return {
                ...state,
                [apiStateName]: action.response
            };
    }
}

function fixAccountsResponseWithUnsupportedMultiProductAccounts(
    response: GetAccountsResponse
) {
    const accounts = _.get(response.data, 'accounts', []);
    if (
        accounts.length === 2 &&
        accounts[0].product_type === FLEXI_LOAN_PRODUCT_TYPE &&
        (!accounts[0].account_id ||
            accounts[0].loan_status === LOAN_STATUSES.ENDED) &&
        accounts[1].product_type === FLEXI_24_PRODUCT_TYPE &&
        accounts[1].loan_status === LOAN_STATUSES.ONGOING
    ) {
        return {
            ...response,
            data: {
                ...response.data,
                accounts: [accounts[1], accounts[0]]
            }
        };
    }

    return response;
}
